/** Facade create/update URLs. Drag and form share PUT + workspace. */

export function equipmentUrl(equipmentId: string, workspace: string): string {
  return `/api/equipment/${equipmentId}?workspace=${workspace}`
}

export function equipmentCreateUrl(dcCode: string, rackId: string | number, workspace: string): string {
  return `/api/datacenters/${dcCode}/racks/${rackId}/equipment?workspace=${workspace}`
}

export function rackEquipmentQueryKey(dcCode: string, rackId: string | number | undefined, workspace: string) {
  return ['rackEquipment', dcCode, rackId, workspace] as const
}
